import { render, staticRenderFns } from "./ReportRestrictionSearch.vue?vue&type=template&id=6a3f0b78&"
import script from "./ReportRestrictionSearch.vue?vue&type=script&lang=js&"
export * from "./ReportRestrictionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports